module.exports = __webpack_public_path__ + "img/open-weather.4175db34.svg";